export default function Footer() {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-8 mt-2">
      <div className="text-center">
        <div className="space-y-1 mb-6 text-sm">
          <p className="font-bold text-gray-800 text-base">Kingcraft Technologies LTD</p>
          <p className="text-gray-500">International House</p>
          <p className="text-gray-500">100 Menzies Road</p>
          <p className="text-gray-500">Hastings, TN38 9BB</p>
          <p className="text-gray-500">United Kingdom</p>
        </div>
        <div className="space-y-2 mb-8">
          <p className="text-sm">
            <a
              href="mailto:support@kingcraftech.com"
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              support@kingcraftech.com
            </a>
          </p>
          <p className="text-gray-600 font-medium text-sm">+44 7451 252956</p>
        </div>
        <div className="flex justify-center">
          <img
            src="https://static.readdy.ai/image/ee0ff265c62d3a2287b67a9d731587ad/da62d47cf3f1a432c6424979b22c5aa4.png"
            alt="Payment Methods"
            className="h-10 object-contain opacity-70"
          />
        </div>
      </div>
    </div>
  );
}
